module.exports = __webpack_public_path__ + "static/media/button-click.200de8e8.mp3";